import type { IRecursive, ITokenSchema } from "@assets/theme/interfaces";

const colors: IRecursive<ITokenSchema<string>> = {
  black: { value: "#000000" },
  brand: {
    bg: { value: "#F8F9FA" },
    authBg: { value: "#2D3656" },
    primary: { value: "#E06E41" },
    secondary: { value: "#A71C27" },
    disabledBtnBg: { value: "#81879A" },
    error: { value: "#E53E3E" },
    red: { value: "#EB4335" },
    grey: { value: "#9b9591" },

    emptyStateText: { value: "#81879A" },
    textSecondary: { value: "#6A7086" },
    warningText: { value: "#7A4210" },

    tableBodyText: { value: "#404040" },
    tableHeaderText: { value: "#B6BAC9" },

    modalHeaderText: { value: "#2D3656" },
    breadcrumbText: { value: "#2D3656" },

    chatMessageBg: { value: "#F2F4F8" },
    chatMessageText: { value: "#404040" },

    activeColor: { value: "#61BB79" },

    white: { value: "#FEFEFF" },
    cancel: { value: "#F1F1F1" },
    checkMark: { value: "#46BA90" },
    secondarySubtitle: { value: "#7E7E7E" },
    label: { value: "#7E7E7E" },
    sidebarBackground: { value: "#3f3754" },
    sidebarItemSelected: { value: "#ACACAC" },
    inputFocusBorder: { value: "#7E7E7E" },
    black: { value: "#171717" },
  },
  grey: {
    5: { value: "#EDF1FF" },
    10: { value: "#B6BAC9" },
    50: { value: "#7f7f7f" },
    100: { value: "#464646" },
  },
  blue: {
    50: { value: "#E9EEF8" },
    300: { value: "#64B5F6" },
    700: { value: "#81879A" },
    800: { value: "#5B6384" },
    900: { value: "#2D3656" },
  },
  score: {
    highBg: { value: "#E8F6ED" },
    highText: { value: "#2F855A" },
    midBg: { value: "#FDF3E2" },
    midText: { value: "#B7791F" },
    lowBg: { value: "#FDECEA" },
    lowText: { value: "#C53030" },
  },
  gray: {
    40: { value: "#F1F1F1" },
    50: { value: "#E7E7E7" },
    60: { value: "#EDEDED" },
    100: { value: "#F1F1F1" },
    200: { value: "#E2E8F0" },
  },
};

export type Colors = typeof colors;
export default colors;
